var map = {
	"./f100.svg": "6d347",
	"./f104.svg": "76cc",
	"./f108.svg": "6156",
	"./f10c.svg": "cd4c",
	"./f113.svg": "2514",
	"./f115.svg": "19d7",
	"./f11b.svg": "af9b",
	"./f11d.svg": "2452",
	"./f120.svg": "5629",
	"./f122.svg": "1b30",
	"./f124.svg": "5ad6",
	"./f128.svg": "d289",
	"./f137.svg": "c6c1",
	"./f139.svg": "7aa6",
	"./f13d.svg": "8035",
	"./f140.svg": "8ac2",
	"./f142.svg": "dd40",
	"./f144.svg": "29cc",
	"./f14a.svg": "13db",
	"./f14c.svg": "7556",
	"./gift.svg": "b355",
	"./pocketMoney.svg": "cb07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a71";